import { useTranslation } from "react-i18next";
import { useJourneyDynamicDetails, useJourneyStaticDetails } from "../../context";
import { getExtrasTotal } from "../TripMoneyBreakdown/utils";
import useTotalFare from "../../hooks/useTotalFare";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { getValues } from "src/utility/objects";
import PaymentChip, { PaymentChipRow } from "../PaymentChip/PaymentChip";
import TotalAmount from "../TotalAmount/TotalAmount";

export default function TotalTopCard() {
  const { t } = useTranslation();
  const { journeyDetails } = useJourneyStaticDetails();
  const { passengersState, payment } = useJourneyDynamicDetails();
  const [passengers] = passengersState;
  const { data } = journeyDetails;
  const currency = data?.fare?.currency ?? "";
  const extras = getExtrasTotal(passengers);
  const { isFetching } = useTotalFare();
  const showSkeleton = isFetching || !payment.selectedPayment;

  const { totalFare, tax } = getValues(data ?? {}, {
    totalFare: { path: ["fare", "publishedFare"], default: 0 },
    tax: { path: ["fare", "tax"], default: 0 },
  });
  const faresSubtotal = totalFare - tax;

  const summaryRows: PaymentChipRow[] = showSkeleton
    ? []
    : [
        ...(faresSubtotal > 0 ? [{ label: t("Flights.details.summary.faresSubtotal"), total: faresSubtotal, currency }] : []),
        ...(tax > 0 ? [{ label: t("Flights.details.summary.taxesAndFees"), total: tax, currency }] : []),
        ...(extras > 0 ? [{ label: t("Flights.details.summary.addonsAndExtras"), total: extras, currency }] : []),
      ];

  return (
    <div className="flex flex-col gap-4 rounded-xl">
      <div className="text-lg text-font-default font-semibold">{t("Flights.details.summary.priceSummary")}</div>

      {showSkeleton ? (
        <div className="flex flex-col gap-3">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex justify-between items-center">
              <SkeletonBox className="h-4 w-24" />
              <SkeletonBox className="h-4 w-16" />
            </div>
          ))}
        </div>
      ) : (
        <PaymentChip rows={summaryRows} title={t("Flights.details.summary.fareBreakdown")} currency={currency} />
      )}
    </div>
  );
}
